import { UserRound } from "lucide-react"

import type { Persona } from "@/componentes/personas/persona"
import { useFotoPersona } from "@/componentes/personas/useFotoPersona"

/**
 * La foto, traída con la sesión puesta.
 *
 * ⚠ **Cómo se pide la foto NO está aquí:** lo sabe `useFotoPersona`, que comparte
 * con el carnet. Aquí sólo está cómo se PINTA en la ficha — un círculo de 80 px.
 *
 * ⚠ **Sin foto se pinta la inicial genérica, no un hueco.** Una ficha a medio cargar
 * y una ficha sin retrato tienen que verse distintas de una rota.
 */
export function RetratoPersona({ persona }: { persona: Persona }) {
  const consulta = useFotoPersona(persona)

  if (!persona.tiene_foto || consulta.isError || !consulta.data) {
    return (
      <span
        aria-hidden={true}
        className="flex h-20 w-20 shrink-0 items-center justify-center rounded-full"
        style={{ backgroundColor: "var(--primary-suave)", color: "var(--primary-texto)" }}
      >
        <UserRound size={32} />
      </span>
    )
  }
  return (
    <img
      src={consulta.data}
      alt={`Foto de ${persona.nombres} ${persona.apellidos}`}
      className="h-20 w-20 shrink-0 rounded-full object-cover"
      style={{ border: "1px solid var(--border)" }}
    />
  )
}
